import RootLayout from '../../layouts/RootLayout';
import { useAuth } from '../../../lib/auth';
import { cn } from '../../../lib/helpers.ts';
import HeadLogo from '../../../components/logos/HeadLogo.tsx';
import SignUpForm from '../../containers/SignUpForm.tsx';

export default function SignUpPage() {
    useAuth({
        middleware: 'guest',
        redirectTo: '/dashboard',
        tmp: 'SignUpPage',
    });

    // const navigate = useNavigate();

    return (
        <RootLayout>
            <main className="container mx-auto flex h-screen flex-col items-center justify-start px-4 py-32">
                <HeadLogo />
                <h1>Registrace</h1>
                <p className={cn('mb-6 text-ink-800', 'text-center')}>
                    Vyzkoušejte demo verzi Všímavce bez nutnosti nákupu roční
                    licence.
                </p>

                <SignUpForm className="mt-12 pb-32" />
            </main>
        </RootLayout>
    );
}
